// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"245":"litigation","531":"firm"}[chunkId] || chunkId) + "." + {"245":"12a2cd3c","531":"090f567f","932":"f3e7752a"}[chunkId] + ".css";
};